import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getById'
})
export class GetByIdPipe implements PipeTransform {

  transform(array: any, args?: any): any {
    const id = args || '';
    if (!array) {
      return {};
    }
    return array.find(item => {
      return item.id == id;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/get-by-id.pipe.ts